function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 19,
  r: 2,
  transform: "rotate(180 12 19)",
  fill: "#929EAA"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 2,
  transform: "rotate(180 12 12)",
  fill: "#929EAA"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 5,
  r: 2,
  transform: "rotate(180 12 5)",
  fill: "#929EAA"
});

const SvgMenuDotted = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuDotted, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu-dotted.65757ccb.svg";
export { ForwardRef as ReactComponent };